import { get } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user']),
  name () {
    return get(this.covenant, 'dependent.name', this.user.name)
  },
  plan_name () {
    return get(this.covenant, 'plan.name', 'Plano não informado')
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/covenants/index/components/resources/computed.js